<template>
  <div>
    <div id="accordion">
      <div
        class="row align-items-center log w-full"
        :id="'heading-' + log.id"
      >
        <div class="col-3 circle-line">
          <i class="fa fa-circle blue-grey" />
          <div class="flex flex-column">
            <div>
              <p class="mb-0 log-time">{{ log.created_time }}</p>
            </div>
          </div>
        </div>
        <div class="col-9 single-log w-full flex flex-wrap"
             data-toggle="collapse"
             data-parent="#accordion"
             :data-target="'#collapse-' + log.id"
             :aria-controls="'#collapse-' + log.id"
        >
          <div class="flex">
            <i class="fa fa-check-circle approved-icon" />
            <p class="log-description m-b">{{ log.title }}</p>
          </div>
          <div class="flex">
            <a href="" class="log-link float-right collapsed"
               data-toggle="collapse"
               data-parent="#accordion"
               :data-target="'#collapse-' + log.id"
               :aria-controls="'#collapse-' + log.id"
            >
              <span class="show-collapsed">
                <i class="fa fa-chevron-down cloudy-blue" />
              </span>
              <span class="show-expanded">
                <i class="fa fa-chevron-up cloudy-blue" />
              </span>
            </a>
          </div>
        </div>
      </div>
      <div :id="'collapse-' + log.id" class="collapse collapse-note col-9 flex float-right" aria-expanded="false" :aria-labelledby="'heading-' + log.id"
           data-parent="#accordion"
      >
        <div class="col-12 single-log note w-full">
          <span>Done by: <b>{{ log.user.username }}</b></span>
          <p class="mt-1 mb-0" v-if="log.from_value"><b>Old value:</b> <br /> {{ log.from_value }}</p>
          <p class="m-0 mt-3" v-if="log.to_value"><b>New value:</b> <br /> {{ log.to_value }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    log: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss">
.collapsing {
  -webkit-transition: none;
  transition: none;
  display: none;
}

.collapse-note {
  padding-right: 0;
  margin-bottom: 8px;
  padding-left: 0;
  margin-top: -15px;
}

.approved-icon {
  color: #2db300;
  margin-right: 8px;
  margin-top: 4px;
}

.log-time {
  font-size: 13px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #4c5669;
  padding: 8px;
}

.log {
  padding-bottom: 8px;
  margin-left: 0 !important;
}

.log > div {
  max-height: 50px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-top: 15px;
  padding-bottom: 10px;

  &:nth-child(2) {
    flex-direction: row;
    justify-content: space-between;
    box-shadow: 0 1px 3px 0 rgba(43, 59, 93, 0.15);
  }
}

.note {
  padding: 2px 14px 14px 14px;
}

.single-log {
  background-color: white;
  min-height: 50px;
  border-radius: 4px;
  box-shadow: 0 1px 3px 0 rgba(43, 59, 93, 0.15);
}

.log-timestamp {
  font-size: 12px;
  font-weight: 500;
  color: #4c5669;
}
.line {
  border: solid 1px #e0e5ea;
  margin: 2px 0 12px 0;
}
.cloudy-blue {
  color: #c0c6cc;
}
</style>



// WEBPACK FOOTER //
// src/components/claims/LogsItem.vue